const config = {
  razorpayKey: "rzp_live_skmGlZBn13v7U6",
  apiBaseUrl: "https://console.hikewise.com/api",
  gaTrackingId: "G-FCGQYEHQ02",
  typeformToken: "",
};

export default config;
